import Loading from "@/pages/loading";
import { DashboardRoutes } from "@/router";
import { useAppDispatch, useAppSelector } from "@/utils";
import { ActivationSteps } from "@payping/api/app/api/bnplMerchantTypes";
import { bnplMerchantGetOptions } from "@payping/redux/actions";
import { useMessagedAsync } from "@payping/web-components";
import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

const BnplManageCreditLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch();

  const contract = useAppSelector((state) => state.bnplMerchant.contract);

  const getOptions = useMessagedAsync(() => dispatch(bnplMerchantGetOptions()), [], { error: true, success: false });

  return (
    <>
      {getOptions.loading || getOptions.error?.name === "AuthError" ? <Loading /> : null}
      {getOptions.error ? <Navigate to={DashboardRoutes.home.root.url} /> : null}

      {!(
        contract?.next === ActivationSteps.NoNext ||
        contract?.next === ActivationSteps.SignContract ||
        contract?.next === ActivationSteps.WaitingForAdmin
      ) ? (
        <Navigate to={DashboardRoutes.myShop.bnpl.activation.root.url} />
      ) : (
        children
      )}
    </>
  );
};

export default BnplManageCreditLayout;
